// touristVehiclesData.js
export const touristVehiclesData = {
  // 🚐 Tempo Traveller
  "9-seater": {
    title: "9 Seater Tempo Traveller",
    image: "https://www.actempotravellerhire.com/images/seater/9-seater-tempo-traveller.webp",
    description: "Perfect for small groups traveling comfortably for city tours or outstation trips.",
    bookingInfo: {
      make: "Force",
      seats: 9,
      driverCharges: "₹800/-",
      outstationFare: "₹20 / Km",
      localFare: "₹3,500/-"
    },
    features: ["Pushback Seats", "AC Available", "Music System"],
  },

  "12-seater": {
    title: "12 Seater Tempo Traveller",
    image: "https://www.rentaltempotravellers.com/wp-content/uploads/2024/05/9-Seater-Luxury-Tempo-Traveller.webp",
    description: "Ideal for slightly bigger families or office trips with extra space and comfort.",
    bookingInfo: {
      make: "Force",
      seats: 12,
      driverCharges: "₹900/-",
      outstationFare: "₹22 / Km",
      localFare: "₹4,500/-"
    },
    features: ["Comfortable Seats", "AC", "Ample Luggage Space"],
  },

  "16-seater": {
    title: "16 Seater Tempo Traveller",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFvNX41rQxDRaWCxFPWzXWgduNS03Iecoi5A&s",
    description: "Spacious option for larger groups traveling to weddings, functions, or long trips.",
    bookingInfo: {
      make: "Force",
      seats: 16,
      driverCharges: "₹1,000/-",
      outstationFare: "₹25 / Km",
      localFare: "₹6,000/-"
    },
    features: ["Pushback Seats", "AC Available", "Charging Points", "Music System"],
  },

  //  Bus Rentals
  "20-seater-bus": {
    title: "20 Seater Mini Bus",
    image: "https://sitaramtours.com/wp-content/uploads/2024/01/20-Seater-Mini-Bus-On-Hire-1.jpg",
    description: "Compact mini bus for short trips, perfect for small events or excursions.",
    bookingInfo: {
      make: "Tata",
      seats: 20,
      driverCharges: "₹1,200/-",
      outstationFare: "₹28 / Km",
      localFare: "₹7,000/-"
    },
    features: ["Comfortable Seating", "Air Conditioning", "Ample Luggage Space"],
  },

  "30-seater-bus": {
    title: "30 Seater Bus Rental",
    image: "https://www.rajasthantourplanner.com/images/bus-rantal-rajasthan.jpg",
    description: "Best for school trips, picnics, and office outings with comfort and safety.",
    bookingInfo: {
      make: "Ashok Leyland",
      seats: 30,
      driverCharges: "₹1,500/-",
      outstationFare: "₹32 / Km",
      localFare: "₹10,000/-"
    },
    features: ["AC Available", "Music System", "Pushback Seats"],
  },

  "40-seater-bus": {
    title: "40 Seater Bus Rental",
    image: "https://delhitempotravels.com/dist/images/40-seater-bus.webp",
    description: "Spacious option for large groups, weddings, or long corporate tours.",
    bookingInfo: {
      make: "Volvo / Leyland",
      seats: 40,
      driverCharges: "₹2,000/-",
      outstationFare: "₹40 / Km",
      localFare: "₹15,000/-"
    },
    features: ["AC Coach", "Luxury Seats", "Ample Legroom", "Storage Space"],
  },

  // Car Rentals
  "maruti-ertiga": {
    title: "Maruti Ertiga",
    image: "https://www.mychoize.com/mychoize-live/current/files/fleets/Maruti_Ertiga_Hybrid.jpg",
    description: "Affordable 7-seater MPV, perfect for family trips in and around the city.",
    bookingInfo: {
      make: "Maruti Suzuki",
      seats: 7,
      driverCharges: "₹600/-",
      outstationFare: "₹13 / Km",
      localFare: "₹2,200/-"
    },
    features: ["AC Available", "Music System", "Ample Boot Space"],
  },

  "toyota-innova": {
    title: "Toyota Innova",
    image: "https://img.autocarpro.in/autocarpro/IMG/797/25797/new-innova2.jpg?w=750&h=490&q=75&c=1",
    description: "India’s most trusted family MPV with comfortable seating for long trips.",
    bookingInfo: {
      make: "Toyota",
      seats: 7,
      driverCharges: "₹700/-",
      outstationFare: "₹15 / Km",
      localFare: "₹2,800/-"
    },
    features: ["AC Available", "Spacious Interiors", "Music System"],
  },

  "innova-hycross": {
    title: "Toyota Innova Hycross",
    image: "https://abhinandantravels.in/wp-content/uploads/2024/06/toyota-innova-hycross-on-rent-abhinandan4.jpg",
    description: "Premium hybrid MPV with luxury interiors for a smooth and fuel-efficient ride.",
    bookingInfo: {
      make: "Toyota",
      seats: 7,
      driverCharges: "₹800/-",
      outstationFare: "₹18 / Km",
      localFare: "₹3,500/-"
    },
    features: ["Hybrid Technology", "Leather Seats", "AC Available", "Ample Space"],
  },

  "swift-dzire": {
    title: "Swift Dzire",
    image: "https://www.carbike360.com/_next/image?url=https%3A%2F%2Fs3.ap-south-1.amazonaws.com%2Fcb360static%2Fuploads%2F93915ea9-f81f-41bb-9972-b286be448b48-small-New%2520Project%2520-%25202025-01-16T161103.598.webp&w=3840&q=75",
    description: "Compact sedan perfect for city travel and small family trips.",
    bookingInfo: {
      make: "Maruti Suzuki",
      seats: 4,
      driverCharges: "₹500/-",
      outstationFare: "₹11 / Km",
      localFare: "₹1,800/-"
    },
    features: ["AC Available", "Music System", "Comfortable Ride"],
  },
};
